import { Button, ButtonProps, Form } from "antd";
import classes from "./FormingAgentInfoForm.module.css";
import { UI_ITODatePicker } from "../../../../UI_ITO/UI_ITODatePicker/UI_ITODatePicker";
import { FormProps } from "antd/lib";
import { IFormingAgentInfoFormProps } from "../../../../interfaces/props/AdminAgentInfo/IFormingAgentInfoFormProps";

export const FormingAgentInfoForm = ({
  formProps = {},
  submitBtnProps = {},
}: IFormingAgentInfoFormProps) => {
  const {
    layout: formLayout = "vertical",
    className: formClassName = "",
    ...restFormProps
  } = formProps;

  const {
    variant: variantSubmitBtn = "solid",
    color: colorSubmitBtn = "primary",
    size: sizeSubmitBtn = "large",
    className: classNameSubmitBtn = "",
    children: childrenSubmitBtn = "Сформировать отчет",
    ...restSubmitBtnProps
  } = submitBtnProps;

  return (
    <Form
      {...restFormProps}
      layout={formLayout}
      className={`${classes.form} ${formClassName}`}
    >
      <Form.Item
        name="startDate"
        className={classes.formItem}
        layout="vertical"
        label={<span className={classes.formItemLabel}>Дата начала:</span>}
      >
        <UI_ITODatePicker className={classes.datePicker} size="large" />
      </Form.Item>

      <Form.Item
        name="endDate"
        className={classes.formItem}
        layout="vertical"
        label={<span className={classes.formItemLabel}>Дата окончания:</span>}
      >
        <UI_ITODatePicker className={classes.datePicker} size="large" />
      </Form.Item>

      <Button
        htmlType="submit"
        {...restSubmitBtnProps}
        variant={variantSubmitBtn}
        color={colorSubmitBtn}
        size={sizeSubmitBtn}
        className={`${classNameSubmitBtn}`}
      >
        {childrenSubmitBtn}
      </Button>
    </Form>
  );
};
